import { beforeAuthGuard } from "@/features/auth/guards";
import { auth } from "@/lib/firebase/client";
import { vaultAppUrl } from "@/lib/vault-app";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  beforeLoad: async ({ location }) => {
    await beforeAuthGuard({ location });
    if (auth.currentUser) {
      const token = await auth.currentUser.getIdTokenResult();
      const activeOrg = token.claims.active_org as string | undefined;
      if (activeOrg?.trim()) {
        throw redirect({ to: "/app/settings/user/profile" });
      } else {
        throw redirect({ href: vaultAppUrl("/settings/profile") });
      }
    }
    throw redirect({ to: "/signin" });
  },
});
